import React from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Journals from "@/pages/Journals";

/**
 * Public-facing wrapper around the dashboard Journals listing so visitors
 * (not just logged-in users) can browse publication venues.
 */
export default function JournalsPublic() {
  return (
    <div className="min-h-screen bg-kb-bg" data-testid="journals-public-page">
      <Navbar />
      <main className="max-w-6xl mx-auto px-6 lg:px-10 pt-16 pb-24">
        <Journals />
      </main>
      <Footer />
    </div>
  );
}
